import React, { useState, useEffect } from 'react'
import Style from './style'

const DurationInput = ({
	inputRef,
	placeholder = '1이상 숫자',
	defaultValue = 3000,
	onKeyDown,
	label = 'Duration:',
}) => {
	const [value, setValue] = useState(defaultValue)

	useEffect(() => {
			setValue(defaultValue)
	}, [defaultValue])

	const handleChange = (e) => {
			setValue(e.target.value)
	}

	return (
		<Style.DurationInputWrapper>
			<Style.Label>{label}</Style.Label>
			<Style.Input
				ref={inputRef}
				placeholder={placeholder}
				value={value}
				onChange={handleChange}
				onKeyDown={onKeyDown}
			/>
			<Style.Unit>ms</Style.Unit>
		</Style.DurationInputWrapper>
	)
}

export default DurationInput
